import ReadonlyEditor from "./ReadonlyEditor";
export default ReadonlyEditor;
